export const pageName = {
  jcal: "Installation Cases",
  alxq: "Case Details",
  ppdt: "Brand Dynamics",
  rz: "Authentication",
  azzd: "Installation Guide",
  by: "Maintenance ",
  cjwt: "Frequently Asked Questions",
  bz: "Help ",
  cpzx: "Product Center",
  gsm: "Wrapping Film",
  zbcx: "Warranty Inquiry",
  jxscx: "Find  Dealer",
  bjcx: "Price Inquiry",
  jjfa: "Solution",
  das: "DAS ",
  zyazry: "Join Dealer",
  azpx: "Installation Training"
};
export default {
  // 首页
  About: {
    progress: "TOPS from Germany · Journey of Craftsmanship",
    brand: "Brand Introduction",
    news: "News Room",

    home: "Home",
    backTop: "Back to Top"
  },
  pageName: pageName,
  // 精彩案例
  WonderfulCase: {
    title: "Installation Cases",
    model: "Installation Model",
    product: "Installation Product",
    productType: "Product Type",
    productModel: "Product Model",
    productProcess: "Product Process",
    nextPage: "Next page",
    prevPage: "Previous page",
    titleDetail: "Wonderful case details"
  },
  // 字典
  dictionary: {
    bannerList: [
      {
        id: "banner-5",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/1.png"
      },
      {
        id: "banner-1",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/2.png"
      },
      {
        id: "banner-2",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/3.png"
      },
      {
        id: "banner-3",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/4.png"
      },
      {
        id: "banner-4",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/5.png"
      },
      {
        id: "banner-6",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/6.png"
      },
      {
        id: "banner-7",
        src: "https://img.topsfilm.com/newportal/img/banner/0616/en/1.png"
      }
    ],
    topList: ["Warranty Inquiry", "FIND A DEALER", "PRICE INQUIRY"],
    navigationList: [
      "ABOUT TOPS",
      "PRODUCT CENTER",
      "SOLUTIONS",
      "PRODUCT CASES",
      "News Center",
      "LOCATION"
    ],
    navigationList2: {
      Product: [
        "Paint Protection Film",
        "G Film (Window Film)",
        "Wrapping Film",
        "Sunroof Protection Film",
        "TPU Headlight Film"
      ],
      Solution: ["TRAINING", "BECOME A DEALER", "SOFTWARE"],
      Case: [
        "Paint Protection Film",
        "G Film (Window Film)",
        "Wrapping Film",
        "Sunroof Protection Film"
      ],
      Address: [
        "Germany",
        "England",
        "USA",
        "Chinese",
        "Chinese-HK",
        "Japan",
        "Australia",
        "Others"
      ]
    },
    navigationList3: {
      "Solution-train": [" Install Training"],
      "Solution-become": ["Join Dealer"],
      "Solution-software": ["DAS"]
    },
    developList: [
      {
        unit: "years",
        text: "PPF Production Experience"
      },
      {
        unit: "years",
        text: "Window Film Production Experience"
      },
      {
        unit: "",
        text: "Luxury Car Film Installation"
      },
      {
        unit: "",
        text: "Cooperation Stores"
      }
    ],
    progressData: {
      first: {
        title: "Set off",
        content: ["In 1978, TOPS established a factory in Munich, Germany."]
      },
      second: {
        title: "Initial",
        content: [
          "In 2016, TOPS R&D center was established in Munich, Germany.",
          "In 2018, TOPS's paint protection film brand,TOPPF® was launched into the global market.",
          "In January 2019, TOPS Asia Pacific Marketing Center was established in Shanghai, China.",
          "In June 2019, four new series of TOPPF® TPU paint protection film products were launched globally.",
          // "In March 2019, TOPPF® brand flagship store was established in Shanghai, China.",
          // "In June 2019, four new series of TOPPF® TPU paint protection film products were launched globally.",
          // "In August 2019, the brand TOPPF® participated in the CIAIE2019 Shanghai International Automotive Interiors and Exteriors Exhibition in China for the first time."
        ]
      },
      third: {
        title: "Process",
        content: [
          "In 2020, TOPS reached cooperation with NIO car company and other luxury car groups.",
          "In January 2020, TOPSFilm™ G Film (Window Film) new products were launched globally.",
          'In September 2020, TOPPF® Sunroof Protecion Film Týr series were launched globally.',
          "In May 2021, TOPS Color Your Infinity™, the brand of wrapping film and high-end customized livery film, under TOPS , was officially established.",
          "In November 2021, TOPS reached a strategic cooperation with RAL Colours from Germany.",
          // "In May 2021, TOPS Color Your Infinity™, the brand of wrapping film and high-end customized livery film, under TOPS , was officially established.",
          // "In August 2021, TOPS new wrapping film product was launched globally.",
          // "In November 2021, TOPS reached a strategic cooperation with RAL Colours from Germany."
        ]
      },
      fourth: {
        title: "Future·Never Stop the Steps"
      }
    },

    brandList: [
      {
        title: "Paint Protection Film",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%BC%86%E9%9D%A2%E8%86%9Clogo.png",
        content:
          "TOPPF® Paint Protection Film, use 8mil-10mil optical TPU+ material, the fourth generation V+ coating, nano-capsule technology which provides strong anti-fouling, high brightness, and yellowing resistance functions. German technology, quality assurance."
          , title1: "TPU Windshield Protection Film"
          ,content1:"TOPPF® TPU Windshield Protection Film, German Technology, Quality Assurance, Defend Your Drive. Impact & Scratch Resistance. Superior Self-healing V+ Coating. High Clarity, Original visibility. Exterior Installation. ",

      },
      {
        title: "Sunroof Protection Film ",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%BC%86%E9%9D%A2%E8%86%9Clogo.png",
        content:
          "TOPPF®  Sunroof Protection Film uses optical-grade TPU substrate with a thickness of up to 8.5 mil; efficient heat insulation and sun protection; clear and transparent, safe and explosion-proof; providing long-term safety protection for car sunroofs."
      },
      {
        title: "TPU Windshield Protection Film",
        logo:
        "https://img.topsfilm.com/newportal/img/brand/en/%E6%BC%86%E9%9D%A2%E8%86%9Clogo.png",
        content:
          "TOPPF® TPU Windshield Protection Film, German Technology, Quality Assurance, Defend Your Drive. Impact & Scratch Resistance. Superior Self-healing V+ Coating. High Clarity, Original visibility. Exterior Installation. "

      }
      , {

        title: "TPU Headlight Film",

        logo:
        "https://img.topsfilm.com/newportal/img/brand/en/%E6%BC%86%E9%9D%A2%E8%86%9Clogo.png",
        content:
          "Engineered specifically to shield car headlights from abrasion, chips, and impacts. Its durable, self-healing TPU material maintains superior clarity and offers proven UV resistance. Trust in lasting protection, backed by a 10-year warranty."
      },

      {
        title: "G Film (Car Window Film)",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E7%AA%97%E8%86%9Clogo.png",
        content:
          "TOPSFilm®  G Film (Car Window Film) adopts TOPS core technology and nano-graphene black gold material, which is the king of new materials and wins the Nobel Prize in the 21st century. It has high heat insulation, high sun protection, zero signal blocking, and is highly suitable for new energy vehicles with intelligent assisted driving functions."
          , title1: "Building Glass Functional Film"
          ,content1:"From intelligent light-adaptive technology and security protection to eco-friendly purification and cost-efficient insulation, TOPSFilm® Building Glass Functional Film fulfills all the premium requirements for architectural solar management.",

      },
      {

        title: "Building Glass Functional Film",

        logo:
        "https://img.topsfilm.com/newportal/img/brand/en/%E7%AA%97%E8%86%9Clogo.png",

        content:
          "From intelligent light-adaptive technology and security protection to eco-friendly purification and cost-efficient insulation, TOPSFilm® Building Glass Functional Film fulfills all the premium requirements for architectural solar management."
      },
      // {
      //   title: "Building Glass Functional Film",
      //   src: "https://img.topsfilm.com/newportal/img/brand/brand-4.png",
      //   bgcImg: "https://img.topsfilm.com/newportal/img/brand/brand-bgc-4.png",
      //   logo:
      //     "https://img.topsfilm.com/newportal/img/brand/en/%E7%AA%97%E8%86%9Clogo.png",
      //   content:
      //     "From intelligent light-adaptive technology and security protection to eco-friendly purification and cost-efficient insulation, TOPSFilm® Building Glass Functional Film fulfills all the premium requirements for architectural solar management."
      // },
      {
        title: "TOPS Wrapping Film",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%94%B9%E8%89%B2%E8%86%9Clogo.png",
        content:
          "TOPS TPU wrapping film adopts optical-grade TPU substrate, German proprietary fourth-generation V+ coating, and nano-capsule technology, which can protect the car and change the color at the same time. 12 color series and hundreds of colors, strategically cooperated with the European century-old color expert RAL Colour from Germany. originated Germany, High-end Color Blending."
        , title1: "TPU Headlight Film"
        ,content1:"Engineered specifically to shield car headlights from abrasion, chips, and impacts. Its durable, self-healing TPU material maintains superior clarity and offers proven UV resistance. Trust in lasting protection, backed by a 10-year warranty."

      },
      {
        title: "Color PPF",
        logo:
          "https://img.topsfilm.com/newportal/img/brand/en/%E6%94%B9%E8%89%B2%E8%86%9Clogo.png",
        content:
          "TOPS TPU Color PPF adopts optical-grade TPU substrate, German proprietary fourth-generation V+ coating, and nano-capsule technology, which can protect the car and change the color at the same time. 12 color series and hundreds of colors, strategically cooperated with the European century-old color expert RAL Colour from Germany. Original from Germany, High-end Color Blending."

      }
    ],

    footerData: {
      product: {
        title: "Product Center",
        content: [
          "Paint Protection Film",
          "G Film (Window Film)",
          "Wrapping Film",
          "Sunroof Protection Film",
          "TPU Headlight Film"
        ]
      },
      Solution: {
        title: "Solution",
        content: [
          // "TRAINING",

          " Install Training",
          // "SOFTWARE",
          "DAS (Data Assist System)"
        ]
      },
      case: {
        title: "Installation Cases",
        content: [
          "Paint Protection Film",
          "G Film (Window Film)",
          "Wrapping Film",
          "Sunroof Protection Film"
        ]
      },
      // help: {
      //   // title: "Help",
      //   // content: []
      // },
      brand: {
        title: "NEWS CENTER",
        content: ["News Room"]
      }
    },
    dASData: {
      first: {
        title: "DAS DATA ASSIST SYSTEM",
        content: [
          "Developed in-house, our DAS (DATA ASSIST SYSTEM) is the world's largest & most comprehensive pattern repository with 140,000+ car data model.In the hands of an TOPS Certified Installer, the patterns offered by the DAS provide the confidence they need to apply film efficiently, accurately and without concern. After becoming our official partner, we will offer a free 2-week trial so you can see just how the precision of our DATA ASSIST SYSTEM patterns can help your business succeed."
        ]
      },
      second: {
        title: "PAINT PROTECTION PATTERNS",
        content: [
          "  Since the early days of TOPS, paint protection patterns have been a cornerstone of our company. The DATA ASSIST SYSTEM allows you to have immediate control over the largest pattern repository on the planet.  The DAS also provides a safe, zero risk installation solution, as it eliminates the need & dangers of hand cutting, reducing installation timelines and improving efficiency by 70%.",
          "Currently, the DAS contains nearly 140,000 paint protection kits for just about every make & model imaginable. All kits are crafted with the best possible fitment & functionality in mind."
        ]
      },
      third: {
        title: "PAINT PROTECTION PATTERNS",
        content: ["TOUR PlUS,TOUR,PHANTOM MATTE,PHANTOM,FEDER"]
      },
      fourth: {
        title: "Precision Patterns",
        content: [
          "Having a software package with lots of bells and whistles is nice, but let's face it -- what really makes the difference in one program over another is the quality of the designs. At TOPS, our two primary design objectives are to allow the film to lay as naturally on the car as possible to avoid unnecessary stretch and contortion, and to ensure perfect alignment with the body panels.",
          "In addition to these two primary objectives, our design team is also committed to providing designs that employ absolutely no unnecessary seams or reliefs. And, if a seam is needed to navigate a particularly complex part, our designers will do everything possible to hide it on a bodyline or on some part of the panel that is out of sight.",
          "Installing properly designed pre-cut kits can make the difference between success and failure in the Paint Protection Film business. Ask for your free 30 day trial today to see how we can help you succeed."
        ]
      },
      fifth: {
        title: "Up To The Minute Availability",
        content: [
          "As TOPS's teams of product engineers work on a daily basis to create design templates for new vehicles, these products are immediately available in the software the instant they are completed. No waiting for update packages to be sent out or downloads to complete. Just use the convenient search interface in the software and every pattern, new and old, is available in real time as soon as they are available."
        ]
      },
      sixth: {
        title: "Variable Geometry",
        content: [
          "Having the pattern you need when you need it is just one part of the equation. To ensure total customer satisfaction regardless of their budget or expectations, you need a cutting program with serious flexibility.",
          "With our patented Variable Geometry functionality, you can safely and quickly implement practically any variation of coverage detail to ensure your customers get the quality they expect at a price they can afford. Wrap any edge, change the amount of coverage or even the design elements of a pattern without the possibility of accidentally making changes that would leave the part unusable."
        ]
      },
      seventh: {
        title:
          "REQUEST MORE INFO<br/>Have A Question About TOPS's DATA ASSIST SYSTEM?<br/>Use The Contact Form Below:",
        content: ["DOWNLOAD DAS"]
      }
    }
  },
  product: {
    productCenter: "PRODUCT CENTER",
    viewDetail: "View Details",
    paintTitle: 'TOPPF® Paint Protection Film "GERMAN" Standard',
    ppf: "Paint Protection Film",
    windowFilm:"Window Film",
    QA: val => {
      return `Warranty Period: ${val} years`;
    },
    standard: "Standard",
    germany: "German",

    parameter: "Product parameters",
    tableDic: {
      model: "Product type",
      visibleLightTransmittance: "VLT",
      totalSolarBarrier: "TSR",
      reflectiveRate: "RR",
      UVBarrier: "UV",
      "5gSignalPassRate": "5G",
      thickness: "Thickness",
      warrantyPeriod: "Warranty period"
    },
    tableDic2: {
      visibleLightTransmittance: "VLT",
      totalSolarBarrier: "TSR",
      infraredBarrierRatio: "IBR",
      UVBarrier: "UV",
      "5gSignalPassRate": "5G",
      thickness: "Thickness",
      warrantyPeriod: "Warranty period"
    }
  },
  dynamic: {
    hot: "Recommend hot topics",
    refresh: "Refresh"
  },
  "pruduct-dict": {
    trait: [
      {
        title: "High Brightness",
        text:
          "German innovative V+ coating technology can effectively increase the brightness of the original paint by more than 30%; TPU substrate has high elasticity, which can effectively defend against stone bullets, and automatically repair minor friction scratches; keep the car body shiny and beautiful, and protect the paint surface without marks as new."
      },
      {
        title: "Strong Anti-fouling",
        text:
          "Nano-capsule technology, anti-fouling technology, combined with bionic principles, creates strong anti-dust and anti-adhesion capabilities, hydrophobic self-cleaning, anti-fouling and anti-scale."
      },
      {
        title: "Yellowing Resistance",
        text:
          "It adopts optical TPU+ substrate to block ultraviolet penetration, anti-oxidation, and high temperature exposure, effectively protecting the texture and gloss of the original paint, and preventing aging and fading."
      }
    ],

    vbot:
      "TOPPF's chief coating R&D senior engineer comes from the world-renowned German coatings company BASF. With the assistance of the R&D department of German Bayer Chemical Company, he successfully developed a proprietary fourth-generation V+ coating nano-capsule technology. TOPPF's proprietary V+ coating has undergone 9,600 hours of rigorous aging testing in the laboratory, which can effectively increase the brightness of the original paint by more than 30%, making the car paint as bright as new.",

    productNameDic: {
      Paint: "Paint Protection Film",
      G: "G Film (Window Film)",
      ColorChange: "Wrapping Film",
      Colorful: "Colorful Film",
      SkyLight: "Sunroof Protection Film",
      Headlight: "TPU Headlight Film",

    },

    // 漆面保护膜
    //    漆面详情
    paintDetailList: [
      {
        "text-cn": "TOUR PLUS",
        title: "TOP ONE",
        content:
          "It uses TOPPF's fourth-generation V+ coating with nano-capsule technology and TPU+10mil thickened substrate, providing ultimate protection. It has super elasticity, high performance corrosion resistance, self-repairing, anti-pollution, anti-scratch and high brightness."
      },
      {
        "text-cn": "TOUR",
        title: "Premium Quality",
        content:
          "Adopts the fourth generation V+ coating of Germany Tofer, nano-capsule technology and optical grade TPU+ high-quality substrate. It has the characteristics of high strength corrosion resistance, self-repairing, anti-pollution, anti-scratch and high brightness."
      },
      {
        "text-cn": "PHANTOM MATTE",
        title: "Luxury and Elegant",
        content:
          "It has a matte satin texture, made of the same TOPPF's fourth-generation V+ coating with nano-capsule technology and casting matte process as the PHANTOM series, providing extraordinary protection for the car body and showing elegance."
      },
      {
        "text-cn": "PHANTOM",
        title: "High-end Player",
        content:
          "Highly transparent and bright paint surface protective film, using TOPPF's fourth-generation V+ coating with nano-capsule technology, its main features are high brightness, strong anti-fouling, and yellowing resistance."
      },
      {
        "text-cn": "FEDER",
        title: "Best Choice",
        content:
          "PDI channel exclusive product, it uses TOPPF's fourth-generation V+ coating with nano-capsule technology, can resist various pollution, high transparency, dazzling, durable and stable, effectively improve the gloss of the original paint. It is the best choice for PDI channel partners."
      },
      {
        "text-cn": "F1",
        title: "Craftsmanship",
        content:
          "Adopting TOPPF's fourth-generation V+ coating with nano-capsule technology, it is resistant to yellowing, easy to apply, self-repairing at room temperature, good value for money, and preferred by stores."
      }
    ],
    //    漆面展示
    paintStandardList: [
      {
        "text-cn": "Dazzling-enhance gloss",
        content:
          "German proprietary fourth-generation V+ coating, and nano-capsule technology, high dazzling brightness, high clarity, effectively improve the surface gloss of the original paint by more than 30%."
      },
      {
        "text-cn": "Anti-fouling-insulates against pollution",
        content:
          "German proprietary fourth-generation V+ coating, and nano-capsule technology, strong anti-dust ability and anti-adhesion ability, prevent bird droppings and dust in the atmosphere from corroding, and effectively protect the original paint from damage."
      },
      {
        "text-cn": "No trace-as long as new",
        content:
          "Powerful self-repair function, small scratches can be repaired automatically, effectively keeping the paint surface as new."
      },
      {
        "text-cn": "Color protection-prevent fading",
        content:
          "Blocking 98% UV, effective protection of the original paint, anti-aging and fading."
      },
      {
        "text-cn": "Protection - resist scratches",
        content:
          "Optical TPU+ base material, super elastic, effectively defends against scratches and stone ejection, and protects the original car paint from damage."
      },
      {
        "text-cn": "Clean-self-cleaning and anti-fouling",
        content:
          "German proprietary fourth-generation V+ coating, and nano-capsule technology, excellent hydrophobic and self-cleaning function, effectively prevent scale damage to car paint."
      }
    ],

    // G速膜
    GData: {
      Dynamic: {
        title: "DYNAMIC SERIES",
        content: [
          {
            id: "Dynamic-1",
            model: "CW75-30",
            thickness: " Thickness: 5mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:75%-30%",


          },
          {
            id: "Dynamic-2",
            model: "CW60-15",
            thickness: " Thickness: 4mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:60%-15%"
          }
        ],
        topText:
          "The Dynamic Series™ series uses TOPS's proprietary technology to achieve intelligent brightness change with the intensity of light. It will not block any 5G signals with efficient heat insulation, safe explosion-proof and UV isolation. 10-year original factory warranty.",
        botTitle: "Advantages of <br/> Dynamic Series™ products",
        botAdvantage: [
          { title: "Talented", text: "Intelligent anti-glare for each comfortable driving trip;" },
          { title: "Outstanding", text: "Micro-level brightness and transparency adjustment;" },
          { title: " Prestigious", text: "Changeable with light, comfortable and enjoyable;" },
          { title: "Safety", text: "Quick response, intelligent and safe;" },
          { title: " Flexible", text: " Protect the eyes with no fear of strong light." }
        ],
        slogan:"- Infinite vision, intelligent brightness",
      },
      SuperDiamond: {
        title: "SUPER DIAMOND SERIES",
        content: [
          {
            id: "SuperDiamond-1",
            model: "T80",
            thickness: " Thickness: 4mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:80%",

          },
          {
            id: "SuperDiamond-2",
            model: "T40",
            thickness: " Thickness: 4mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:38%"
          },
          {
            id: "SuperDiamond-3",
            model: "T15",
            thickness: " Thickness: 4mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:15%"
          }
        ],
        topText:
          "Super Diamond Series adopts TOPS's patented nano-graphene black gold film layer, which has no signal blocking interference, non-metallic material, 100% non-oxidation, constant color, and no fading worries. It uses non-metallic 'film' technology and allow full transmission of signal of mobile phone/GPS/ETC, which is significant for high-tech smart transportation in the 5G era, highly adapted to new energy vehicles, and escort for the full opening of unmanned driving technology. High light transmittance, high definition, low reflection, providing the clearest front view, ensuring safe driving at night. 10-year original factory warranty, durable and long-lasting.",
        botTitle: "Advantages of Super Diamond Series Products",
        botAdvantage: [
          { text: "Zero blocking of 5G signal, precise docking of smart travel. " },
          { text:"Black gold safety net, high-tech protection."},
          { text:" Top heat insulation, strong sun protection. "},
          { text:"High UV isolation, reducing the harm of photo-aging. "},
          { text:"High definition, unobstructed vision."},
          { text:" No oxidation, durable. Guarantee 10-year original factory warranty."}
        ],
        slogan:"- Black gold technology, enjoyable life",
      },
      Diamond: {
        title: "DIAMOND SERIES",
        content: [
          {
            id: "Diamond-1",
            model: "O80",
            thickness: " Thickness: 2mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:80%"
          },
          {
            id: "Diamond-4",
            model: "O35",
            thickness: "Thickness: 2mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:36%",

          }

        ],
        special: [

          {
            id: "Diamond-2",
            model: "O25",
            thickness: " Thickness: 2mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:20%"
          },
          {
            id: "Diamond-3",
            model: "O15",
            thickness: " Thickness: 2mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:15%"
          },
          {
            id: "Diamond-5",
            model: "O05",
            thickness: " Thickness: 2mil",
            warrantyPeriod: "Warranty Period:10 Years",
            visibleLightTransmittance: "VLT:5%",

          }
        ],
        topText:
          "Diamond Series uses TOPS's patented nano-graphene black gold film layer, which has no signal blocking interference, non-metallic material, 100% non-oxidation, constant color, and no fading worries. It uses non-metallic 'film technology and allow full transmission of signal of mobile phone/GPS/ETC, which is significant for high-tech smart transportation in the 5G era, highly adapted to new energy vehicles, and escort for the full opening of unmanned driving technology. High light transmittance, high definition, low reflection, providing the clearest front view, ensuring safe driving at night. 10-year original factory warranty, durable and long-lasting.",
        botTitle: "Advantages of Diamond Series Products",
        botAdvantage: [
          { text: "Zero blocking of 5G signal, precise docking of smart travel."},
          { text: "Black gold safety net, high-tech protection."},
          { text: "Top heat insulation, strong sun protection."},
          { text: "High UV isolation, reducing the harm of photo-aging."},
          { text: "High definition, unobstructed vision. No oxidation, durable."},
          { text: "Guarantee 10-year original factory warranty."},
        ],
        slogan:"- Crystal window film, shining life",

      },
      Crystal: {
        title: "CAYSTAL SERIES",
        content: [
          {
            id: "Crystal-1",
            model: "S75",
            thickness: " Thickness: 2.5mil",
            warrantyPeriod: "Warranty Period:5 Years",
            visibleLightTransmittance: "VLT:75%"
          },
          {
            id: "Crystal-2",
            model: "S35",
            thickness: " Thickness: 2.5mil",
            warrantyPeriod: "Warranty Period:5 Years",
            visibleLightTransmittance: "VLT:35%"
          },
          {
            id: "Crystal-3",
            model: "S15",
            thickness: " Thickness: 2.5mil",
            warrantyPeriod: "Warranty Period:5 Years",
            visibleLightTransmittance: "VLT:15%"
          }
        ],
        topText:
          "The Crystal Series uses TOPS's patented nanographene black gold film layer, which has no signal blocking interference; it has unique spectral selective reflection, high-efficiency heat insulation, quickly and effectively reduces the temperature in the car, and comprehensively improves driving comfort. It separates the world of ice and fire with a film, creating a cool and refreshing car life. It effectively blocks 99.9% of ultraviolet rays and provides a sun protection value equivalent to SPF1000+, which is 30 times the sun protection value of daily sunscreen skin care products. It effectively protects skin health and the fading and aging of the interior of your car, while effectively reducing the damage of ultraviolet rays to the eyes and protecting the health and safety of your family. 5-year original factory warranty, no oxidation, and long-lasting.",
        botTitle: "Advantages of Crystal Series Products",
        botAdvantage: [
          { text:"5G signal zero blocking, precise docking of smart travel."},
          { text: "Full skin protection, strong sun protection."},
          { text:"100% ultraviolet isolation, reducing the harm of light aging."},
          { text:"High definition, unobstructed vision."},
          { text:"No oxidation, long-lasting. "},
          { text:"5-year original factory warranty."},
        ],
        slogan:"- Crystal window film,  pleasing life",
      },
 //F70 F30 F20 F10
 F:{
  // F系列
  id: "G-5",
  title: "CRYSTAL ENJOYMENT SERIES",
  src:
    "https://img.topsfilm.com/newportal/img/product/G/color-bound-jingyao.png",
    content: [
      {
        id: "F-70",
        model: "F70",
        thickness: " Thickness: 2mil",
        warrantyPeriod: "Warranty Period:7 Years",
        visibleLightTransmittance: "VLT:70%"

      },
      {
        id: "F-30",
        model: "F30",
        thickness: " Thickness: 2mil",
        warrantyPeriod: "Warranty Period:7 Years",
        visibleLightTransmittance: "VLT:30%"

      },
      {
        id: "F-20",
        model: "F20",
        thickness: " Thickness: 2mil",
        warrantyPeriod: "Warranty Period:7 Years",
        visibleLightTransmittance: "VLT:20%"

      },
      {
        id: "F-10",
        model: "F10",
        thickness: " Thickness: 2mil",
        warrantyPeriod: "Warranty Period:7 Years",
        visibleLightTransmittance: "VLT:10%"

      },
    ],
   topText: "Crystal Enjoyment Series uses TOPS's patented nano-graphene<br/> black gold film layer, which has no signal blocking interference, non-metallic material, 100% non-oxidation, constant color, and no fading worries. It uses non-metallic 'film technology and allow full transmission of signal of mobile phone/GPS/ETC, which is significant for high-tech smart transportation in the 5G era, highly adapted to new energy vehicles, and escort for the full opening of unmanned driving technology. High light transmittance, high definition, low reflection, providing the clearest front view, ensuring safe driving at night. 7-year original factory warranty, durable and long-lasting.   ",
   botTitle: "Advantages of Crystal Enjoyment Series Products",
   botAdvantage: [
    { text:"5G signal zero blocking, precise docking of smart travel."},
    { text: "99% ultraviolet isolation, reducing the harm of light aging."},
    { text:"High definition, unobstructed vision."},
    { text:"No oxidation, long-lasting. "},
    { text:"7-year original factory warranty."},
  ],
  slogan:"- Crystal window film,  pleasing life",

}
    },
    //     窗膜
    windowMembraneList: {
      titlesrc: "https://img.topsfilm.com/newportal/img/product/G/en-GGG.png",
      newenergySrc:"https://img.topsfilm.com/newportal/img/product/G/newenergy2En.png",
      content: [
        "",
        "Zero blocking of 5G signal,<br/>precise docking and intelligent travel.",
        "Nano-graphene black gold material, <br/>High-tech protection.",
        "Top heat insulation, strong sun protection.",
        "High UV isolation,<br/>Reduce the harm of photoaging.",
        "High definition, unobstructed vision.",
        "No oxidation, durable.",
        "Guarantee up to 10-year original factory warranty."
      ]
    },
    // 改色膜
    colorChangeData: {
      series: {
        classic: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/classic-colorful.png",
          data: [
            "Genesis Grey Space Series",
            "Dark Gothic Series",
            "Splendid Galaxy Series",
            "Inspirational Muse Series",
            "Illusory Europe Series",
            "Impressional France Series",
            "Duke Deluxe Series",
            "Glamorous Queens Series",
            "Romantic Venus Series",
            "Fantastic Van Gogh Series"
          ]
        },
        enjoy: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/enjoy-colorful.png",

          data: [
            "Genesis Grey Space Series",
            "Dark Gothic Series",
            "Splendid Galaxy Series",
            "Golden Flame Series",
            "Saint Violet Series",
            "Impressional France Series",
            "Duke Deluxe Series",
            "Glamorous Queens Series",
            "Romantic Venus Series",
            "Fantastic Van Gogh Series"
          ]
        },
        luxurious: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/luxurious-colorful.png",

          data: [
            "Munich Series",
            "Berlin Series",
            "Hamburg Series",
            "Rhine Series",
            "Cologne Series",
            "Stuttgart Series"
          ]
        },
        custom: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/custom-colorful.png",

          data: [
            "Category A Partial car simple wrap livery",
            "Category B Full car simple wrap livery",
            "Category C Full car wrap livery",
            "Category D Full car complicated wrap livery"
          ]
        }
      },
      membrane: {
        1: {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/product/ColorChange/en/colorfultext.png",
          text:
            "RAL Colours from Germany Exclusive Design<br/> RAL X TOPS <br/>TOPS & RAL Colours Agreed On A Long-term Exclusive Strategic Cooperation"
        },
        2: {
          title: "About RAL Colours",
          "text-t":
            "Founded in 1925, RAL is a German company with a history of nearly 100 years. RAL Colours has many world firsts and unique technologies in the field of color standardization, and is the communication language of the world of color used worldwide.",
          "text-b":
            "Till now, RAL Colours has become synonymous with the global color system and color classification system that is independent of manufacturers in the eyes of professional color designers. RAL Colours has a total of 2,328 colors, and its products include fan-shaped color cards, original color standards, plastic color standards, color digitization software, and color design and trend books. In many industrial fields such as automotive paints and body coatings, RAL Colours is used as an authoritative color standard."
        }
      },
      perfect: [
        {
          // "logo-text":
          //   "TOPS & RAL Colours Agreed On A Long-term Exclusive Strategic Cooperation"
        }
      ]
    },

    // 天窗膜
    skylightData: {
      series: [
        {
          titlesrc:
            "https://img.topsfilm.com/newportal/img/public/logoEn.png",
          text: "TOPPF Sunroof Protection Film<br/>TYR Series",
          detail: {
            title: "TOPPF Sunroof <br/> Protection FilmTYR Series",
            weilai: {
              title:
                "TOPPF——The exclusive designated supplier of sunroof heat-insulation film for NIO",
            },
            maxList: [
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-1.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-2.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-3.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-4.png",
              "https://img.topsfilm.com/newportal/img/product/SkyLight/details/value-5.png"
            ]
          }
        }
      ],
      membrane: [
        "TOPPF——The exclusive designated supplier of sunroof heat-insulation film for NIO",
        `'<div>Safety MAX</div><br/><span class="text">safe and explosion-proof, reliable protection</span>`,
        `<div>Sun-protection MAX</div><br/><span class="text">Efficient sun-protection, sustain a cool environment and protect your skin</span>`,
        `<div>Coolness MAX</div><br/><span>Quickly cool down，create a comfortable driving experience</span>`,
        `<div>Clarity MAX</div><br/><span class="text">Self-repairing capability，maintain a clear and transparent vision</span>`,
        `<div>Speed MAX</div><br/><span class="text">No need to wait, stick and go</span>`
      ]
    }
  },
  help: {
    name: "Name",
    city: "City",
    lastName: "LastName",
    province: "Region",
    companyName: "CompanyName",
    country: "Country",
    email: "Email",
    zipCode: "Zip",
    phone: "Phone",
    adress: "Address",
    addressTwo: "AddressTwo",
    content: "RequestDetails",
    submit: "Submit",
    resetForm: "ResetForm",
    formTitle: "Information table",
    formdes: "Required information*"
  },
  train: {
    title: "Committed To Installation Quality",
    text:
      "Committed to offer the customers with quality installations of TOPPF products is extremely important to your success in the Paint Protection industry. For that reason, TOPPF offers a very thorough set of installation training courses which have been consistently rated as the best in the industry.",
    text1:
      "We guide our trainees through a profession process that is both intellectual and hands-on. Our comprehensive PPF install training curriculum covers topics ranging from the inner workings of our DAS software to the latest, most innovative installation techniques for paint and headlamp protection film.",
    callingText: "Please email ",


    knowMore: "to learn more or to schedule your class.",
    trainingclass: "TRAINING CLASSES",
    courseList: [
      {
        id: "course-1",
        title: "Training Class",
        content: [
          "Installation Training",
          "Master Training",
          "Master of master Training"
        ]
      },
      {
        id: "course-2",
        title: "Duration",
        content: ["Four(4) Days", "Three(3) Days", "Two(2) Days"]
      },
      // {
      //   id: "course-3",
      //   title: "Cost",
      //   content: ["€600", "€500", "€400"]
      // }
    ],
    installationTrainingTitle: "Installation Training",
    installationTrainingContent:
      "We offer all classes at the TOPPF Training Center, Which is located in Germanv and Shanghai China. Our PPF install training benefits the novice and advanced installer with a purposefully structured syllabus for each skill level. Trainees receive the personal attention that will enable them to gain the skills necessary to provide quality, trouble-free installations on even the most challenging of vehicles.",
    installationTrainingContent1:
      "We also offer complete instruction on the use of our Data Assist System (DAS) software and associated hardware. We will supply you with a training manual, all necessary materials, and tools. In order to ensure an adequate amount of specialized attention, class sizes are normally limited to four trainees per instructor.",
    installationTrainingContent2:
      "If you would like more information, please email info@topsfilm.com to consult with company representative.",
    internationalTrainingAvailable: "INTERNATIONAL TRAINING AVAILABLE",
    gcompanyName: "TOPS Germany",
    gadress: "Theresienhoehe 28, Munich, Germany",
    gphone: "+49 89 24440 7026",
    gworkTime: "9:00-6:00 CST",
    gdes:
      "TOPS German headquarters is located in Theresienhoehe 28, Munich, Germany, providing training for customers in all regions.",
    formTitle:
      "REQUEST MORE INFO<br/>Have A Question About TOPPF PPF Installation Training?<br/>Use The Contact Form Below:"
  },
  joinDealer: {
    formTitle:
      "REQUEST MORE INFO<br/>Have A Question About TOPS Join Dealer?<br/>Use The Contact Form Below:",
    title: "Offer The People What They Need. TOPS Is The Enthusiast's Choice.",
    content:
      "Dedicating to lead the industry, TOPS products have redefined the way the public thinks about high performance protection & precision film installations. With roots in pattern design and software development, we're driven to increase our professional installers profitability and maximize returns. We are ready to support your business to the next level with our advanced automotive, residential, and commercial window films, paint protection film, installation tools, aftercare products, and the most comprehensive training programs in the industry.",
    nmoreInfo: " MORE INFO↓",
    findDealer: "FIND  DEALER",

    dealerPhotop: "Dealer Spotlight",
    success: "We Set You Up For Success",
    successDes:
      "Here at TOPS we are invested heavily in helping our family of professional installers reach their business goals on the road towards long term success.",
    advantageTitle: "Benefits Of Being An Dealer:",
    advantageList: [
      "High-ranked positioning in top search engine results thanks to our unique Installer Locator.",
      "Immediate connectivity to TOPS's Global Customer Service Team, 24 hours a day & 7 days a week.",
      "A dedicated sales professional to help grow your business operations in the retail & wholesale marketplace.",
      "Access to branding & marketing resources to transform the face of your company in person & online."
    ],
    curx: "KEYS TO SUCCESS",
    curxtitle: "Unparalleled Training",
    curxcontent:
      "Top tier installations begin with a strong skill set. Here at TOPS, we offer the highest rated & most comprehensive training regiment in the industry. With over many years of film installation training under our belts, our certification program will provide you with the knowledgebase you need to begin your journey.",

    curxtitle1: "Bespoke Software",
    curxcontent1:
      " As the creators & and innovators of pre-cut kits, our world renowned Data assist system(DAS) will help you stay a cut above the competition with maximum efficiency. Comprised of over 140,000 patterns and growing, the DAS enables you to provide your customers with the level of precision they desire."
  },
  distributor: {
    title: "Find An Authorized TOPS Dealer",
    country: "DISTRICT/COUNTY",
    select: "--SELECT--",
    province: "DISTRIBUTOR",
    city: "CITY",
    noresult: "No-Data",
    query: "Query",
    queryMap: "Map"
  },
  bottomNavigation: {
    title: "Contact Us:",
    edAdressTitle: "Global Headquarters",
    edAdress:"Professor-Messerschmitt-Str. 3a, 85579 Neubiberg, Germany",
adressTitle:"Asia Pacific Headquarters",
    adress:
      "Address: Building C3 , No 689 , Guanghua Rd. Minhang district , Shanghai , China ",
    helpList: [
      {
        text: "Find an TOPS Dealer Near You"
      },
      {
        text: "Coverage Options For My Car→"
      },
      {
        text: " Become a Dealer →"
      }
    ]
  },
  warranty: {
    query: "Inquiry",
    warrantyQuery: "Warranty Query",
    phone: "Mobile Number：",
    enterPhone:" mobile number",//Please enter your phone number
    plateNumber: "License Plate Number:",//
    enterPlateNumber: "  license plate number or vehicle frame number",//Please enter the license plate number or chassis number
    digitalCertification:"Warranty Card",
  },
  offer: {
    title: "Select your vehicle below to view available TOPPF paint protection film pre-cut kits.    ",
    subTitle: "Pricing suggestions shown include application price.",
    brand: "Brand：",
    model: "Model：",
    filmType:"Film Type：",
    pleaseSelectBrand: "Please select brand",
    pleaseSelectModel: "Please select model",
    pleaseSelectFilmType: "Select film type",
    selectAddtoCart: "Part",
    description: "Description",
    information: "Information",
    price: "price",
    entireVehicle: "Entire Vehicle",
    frontBumper: "FrontBumper",
    hood: "Hood",
    frontFender: "Front Fender",
    door:"Door",
    roof: "Roof",
    rearFender:"Rear Fender",
    tailHood: "Tail Hood",
    rearBumper:"Rear Bumper",
  }
};



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js